import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","gap":"10px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" - ")

import { options_2, getOptions } from "@/utils/imageLabel.util.ts";
import { CascadeOption } from "@/types/genericData";
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { FilterImagesLabel } from "@/types/imageLabel.type.ts";
import { getParameterList } from "@/service/parameter.service";
import { Parameter } from "@/types/parameter.type";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const route = useRoute();

const options_1 = ref<CascadeOption>();
const value1 = ref([] as string);
const value2 = ref([] as string);

const optionsImages = ref<FilterImagesLabel>({
  label: undefined,
  lighting_condition: undefined,
  estimations: undefined,
  training_data: undefined,
  type: undefined,
  origin: undefined,
  parameter: undefined,
  values: [undefined, undefined],
  relationStatus: undefined,
});

const organicOrigins = [
  "DUERO",
  "LABORATORIO",
  "MULTIPARAMETRICA",
  "SAK",
  "SCADA",
  "SCRAPPING",
  "SONDA_DQO",
  "OTRO",
];

const codeParams = ref<Parameter[]>([]);

const handleChangelighting_condition = () => {
  optionsImages.value.lighting_condition =
    value2.value && value2.value.length > 0 ? value2.value.join("_") : undefined;
};

const isDisabled = () => {
  return optionsImages.value.estimations || optionsImages.value.training_data ? true : false;
};

const isDisabledEstimations = () => {
  return optionsImages.value.training_data ||
    (value1.value && value1.value.length > 0) ||
    (value2.value && value2.value.length > 0)
    ? true
    : false;
};

const isDisabledTrainingData = () => {
  return optionsImages.value.estimations ||
    (value1.value && value1.value.length > 0) ||
    (value2.value && value2.value.length > 0)
    ? true
    : false;
};

/**
 * Actualizar componente
 * Se llama desde otro componente
 * @param applyFilter
 */
const updateOptionsImage = (applyFilter: boolean) => {
  //- Quitar filtros
  if (!applyFilter) {
    optionsImages.value.label = undefined;
    optionsImages.value.lighting_condition = undefined;
    value2.value = [];
    optionsImages.value.estimations = undefined;
    optionsImages.value.training_data = undefined;

    //Relaciones
    optionsImages.value.relationStatus = undefined;
    //Tipo
    optionsImages.value.type = undefined;
    //Origen
    optionsImages.value.origin = undefined;
    //Parámetro
    optionsImages.value.parameter = undefined;
    //Valores
    optionsImages.value.values = [undefined, undefined];
  } else {
    optionsImages.value.label = value1.value && value1.value.length > 0 ? value1.value : undefined;
    handleChangelighting_condition();
  }

  return optionsImages.value;
};

onMounted(async () => {
  options_1.value = await getOptions(route.query.samplingPoint);
  const response = await getParameterList();
  codeParams.value = response.data;
});

expose({
  updateOptionsImage,
});

return (_ctx: any,_cache: any) => {
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, { "label-position": "top" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('label.waterTypology')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_cascader, {
            modelValue: value1.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value1).value = $event)),
            props: {
          checkStrictly: true,
        },
            clearable: "",
            "show-all-levels": false,
            disabled: isDisabled(),
            options: options_1.value
          }, null, 8, ["modelValue", "disabled", "options"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('magnitude.luminosity')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_cascader, {
            modelValue: value2.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value2).value = $event)),
            clearable: "",
            disabled: isDisabled(),
            options: _unref(options_2)
          }, null, 8, ["modelValue", "disabled", "options"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('label.estimations')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: optionsImages.value.estimations,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((optionsImages.value.estimations) = $event)),
            clearable: "",
            disabled: isDisabledEstimations()
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: _ctx.$t('options.withEstimations'),
                value: "with"
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t('options.withoutEstimations'),
                value: "without"
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('label.trainingData')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: optionsImages.value.training_data,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((optionsImages.value.training_data) = $event)),
            clearable: "",
            disabled: isDisabledTrainingData()
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: _ctx.$t('options.withTrainingData'),
                value: "with"
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t('options.withoutTrainingData'),
                value: "without"
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, { label: "Asignación de muestra" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: optionsImages.value.relationStatus,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((optionsImages.value.relationStatus) = $event)),
            clearable: "",
            placeholder: "Seleccionar"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "Más cercana",
                value: "CLOSEST"
              }),
              _createVNode(_component_el_option, {
                label: "Extra",
                value: "EXTRA"
              }),
              _createVNode(_component_el_option, {
                label: "Manual",
                value: "MANUAL"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('label.type')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: optionsImages.value.type,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((optionsImages.value.type) = $event)),
            clearable: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "Orgánica",
                value: "ORGANICO"
              }),
              _createVNode(_component_el_option, {
                label: "Sintética",
                value: "SINTETICO"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('label.origin')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: optionsImages.value.origin,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((optionsImages.value.origin) = $event)),
            clearable: "",
            disabled: optionsImages.value.type !== 'ORGANICO'
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(organicOrigins, (item) => {
                return _createVNode(_component_el_option, {
                  key: item,
                  label: item,
                  value: item
                }, null, 8, ["label", "value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('label.parameter')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: optionsImages.value.parameter,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((optionsImages.value.parameter) = $event)),
            clearable: "",
            filterable: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codeParams.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.code,
                  label: item.name,
                  value: item.code
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('label.values')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_input_number, {
              modelValue: optionsImages.value.values[0],
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((optionsImages.value.values[0]) = $event)),
              placeholder: "Valor 1",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _hoisted_2,
            _createVNode(_component_el_input_number, {
              modelValue: optionsImages.value.values[1],
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((optionsImages.value.values[1]) = $event)),
              placeholder: "Valor 2",
              clearable: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _: 1
  }))
}
}

})